import * as apiTo from '@/modular-api'

async function getAndSetProductsSubjectCategories(commit, productId) {
  commit('toggleFetchingSubjectCategories', true)

  return apiTo
    .GET_PRODUCTS_SUBJECT_CATEGORIES(productId)
    .finally(() => commit('toggleFetchingSubjectCategories', false))
}

export function getAndSetData({ commit }, productId) {
  return Promise.all([
    apiTo.GET_PRODUCT(productId),
    getAndSetProductsSubjectCategories(commit, productId),
    apiTo.GET_SUBJECT_CATEGORIES(),
    apiTo.GET_INLINE_EDITING_FOR_PRODUCT()
  ]).then(requests => {
    commit('setProduct', requests[0].data.result)
    commit('setAssignedSubjectCategories', requests[1].data.result)
    commit('setAllSubjectCategories', requests[2].data.result)
    commit('setEditingData', requests[3].data.result)

    return requests
  })
}

export function fetchAssignedSubjectCategories({ commit, state }) {
  return getAndSetProductsSubjectCategories(commit, state.product.id).then(({ data }) => {
    commit('setAssignedSubjectCategories', data.result)
  })
}

export function updateProduct({ commit, state }, payload) {
  return apiTo.UPDATE_PRODUCT(state.product.id, payload).then(({ data }) => {
    commit('setProduct', data.result)
    return data.result
  })
}

export function createSubjectCategory({ commit, dispatch }, name) {
  return apiTo.CREATE_SUBJECT_CATEGORY({ name }).then(({ data }) => {
    commit('addSubjectCategory', data.result)
    dispatch('assignSubjectCategory', data.result.id)
    return data.result
  })
}

export function assignSubjectCategory({ commit, state }, subjectCategoryId) {
  return apiTo.ADD_SUBJECT_CATEGORY_TO_PRODUCT(state.product.id, subjectCategoryId).then(({ data }) => {
    commit('assignSubjectCategory', data.result)
    return data.result
  })
}

export async function changeMainCategory({ commit, dispatch }, payload) {
  await dispatch('updateProduct', payload)
  commit('removeActiveMainCategory')
  commit('setActiveMainCategory', payload.main_subject_category_id)
}

export function removeFromProduct({ commit, dispatch, state }, { id: subjId, is_main_category: isMain }) {
  const prodId = state.product.id

  if (isMain) {
    return Promise.all([
      dispatch('updateProduct', { main_subject_category_id: null }),
      apiTo.REMOVE_SUBJECT_CATEGORY_FROM_PRODUCT(prodId, subjId)
    ]).then(() => commit('removeSubjectCategory', subjId))
  } else {
    return apiTo
      .REMOVE_SUBJECT_CATEGORY_FROM_PRODUCT(prodId, subjId)
      .then(() => commit('removeSubjectCategory', subjId))
  }
}

export function getAndSetTitleLists({ commit, state }) {
  return apiTo.GET_PRODUCTS_TITLE_LISTS(state.product.id).then(({ data }) => {
    commit('setTitleLists', data.result)
    return data.result
  })
}

export function getAndSetSubscriptions({ commit, state }) {
  return apiTo.GET_PRODUCTS_SUBSCRIPTIONS(state.product.id).then(({ data }) => {
    commit('setSubscriptions', data.result)
    return data.result
  })
}

export function updateField({ commit, dispatch, state }, { set, field, cancel, value, setLoading }) {
  setLoading(true)

  dispatch('updateProduct', { [field]: value || null })
    .then(() => {
      set()
      if (field === 'main_subject_category_id' && value) dispatch('fetchAssignedSubjectCategories')
      if (['online_identifier', 'print_identifier'].includes(field)) dispatch('getAndSetTitleLists')
    })
    .catch(cancel)
    .finally(() => setLoading(false))
}
